module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-52-min.87b697ae.jpg";